module.exports = __webpack_public_path__ + "img/video-poster.35d7d4f6.png";